module.exports = __webpack_public_path__ + "ddc3655e242dedf46d8e88f24df8ec49.png";